module.exports = __webpack_public_path__ + "static/media/csrddc2.b2a914ec.svg";